import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  INotApplicableCriteria,
  NotApplicableCriteriaModel,
} from 'src/app/shared/models/not-applicable-criteria.model';
import { arrayOfType } from 'src/app/shared/utils/data.utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotApplicableCriteriaService {
  constructor(private readonly httpClient: HttpClient) {}

  getNotApplicableCriteriaExamples(): Observable<INotApplicableCriteria[]> {
    return this.httpClient
      .get<
        INotApplicableCriteria[]
      >(`${environment.scorecards_api_url}/v1/scorecards/questions/criteriaExamples/notApplicable`)
      .pipe(map((response) => arrayOfType(response, NotApplicableCriteriaModel)));
  }
}
